import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CHANGE_PERSONAL_INFO_CLICKED, CHANGE_PHONE_NUMBER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    AUTH_PROFILE_CHANGE_EMAIL,
    AUTH_PROFILE_CHANGE_PHONE,
    AUTH_PROFILE_EDIT_PERSONAL_INFO,
    AUTH_PROFILE_EDIT_PROFILE,
} from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ChangePersonalInfoPopup = ({ popupRef, canEditEmail, canEditPhone, canEditPersonalDetails, toggleSpinner }) => {
    const { profileChangePersonalInfo, profileChangeMobilePhone, emailPopupChangeEmail } = usePageMessages();
    const { newProfileEditFlow } = useExtra();

    return (
        <SimplePopup withoutBorder popupRef={popupRef}>
            {canEditPersonalDetails && (
                <PopupButton
                    href={newProfileEditFlow ? AUTH_PROFILE_EDIT_PERSONAL_INFO : AUTH_PROFILE_EDIT_PROFILE}
                    iconName="person"
                    text={profileChangePersonalInfo}
                    onClick={() => {
                        amplitude.getInstance().logEvent(CHANGE_PERSONAL_INFO_CLICKED);
                        toggleSpinner(true);
                        popupRef.current?.close();
                    }}
                />
            )}
            {canEditPhone && (
                <PopupButton
                    href={AUTH_PROFILE_CHANGE_PHONE}
                    iconName="mobile"
                    text={profileChangeMobilePhone}
                    onClick={() => {
                        amplitude.getInstance().logEvent(CHANGE_PHONE_NUMBER_CLICKED);
                        toggleSpinner(true);
                        popupRef.current?.close();
                    }}
                />
            )}
            {canEditEmail && (
                <PopupButton
                    href={AUTH_PROFILE_CHANGE_EMAIL}
                    iconName="mail"
                    text={emailPopupChangeEmail}
                    onClick={() => {
                        toggleSpinner(true);
                        popupRef.current?.close();
                    }}
                />
            )}
        </SimplePopup>
    );
};

export default connect(null, { toggleSpinner })(ChangePersonalInfoPopup);
